import React, { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment";
import { Mensaje } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import useTable from "../../useTableR";
import { ModalCuentaEstado } from "./modalEstadoLic";
import { SearchInput } from "../../../ui/inputs/Input";

export function TablaEstadoLicores(props) {
  let op = require("../../../modulos/datos");
  let token = localStorage.getItem("jwtToken");

  const headCells = [
    {
      id: "idcomercio",
      label: "CODIGO",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "ritm",
      label: "RITM",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "rif",
      label: "RIF",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "nombre",
      label: "NOMBRE",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "reprelegal",
      label: "CEDULA RESPONSABLE",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "accion",
      label: "OPCIONES",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
  ];

  const [mostrar5, setMostrar5] = useState(false);
  const [activate, setActivate] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => items,
  });
  const [comercio, setComercio] = useState();
  const [declaWeb, setDeclaWeb] = useState(false);
  const [valorUT, setValorUT] = useState();
  const [deuda, setDeuda] = useState();
  const [historico, setHistorico] = useState();

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const handleSearch2 = (e) => {
    let target = e.target;
    if (target.name === "Search") {
      target.value = target.value.toUpperCase();
      setFilterFn({
        fn: (items) => {
          if (target.value === "") {
            return items;
          } else {
            return items.filter((x) => {
              if (
                x.idcomercio.toString().includes(target.value) ||
                x.nombre.toLowerCase().includes(target.value.toLowerCase()) ||
                x.rif.toLowerCase().includes(target.value)
              ) {
                return x;
              }
            });
          }
        },
      });
    }
  };

  const cerrarModalActualizar = () => {
    setMostrar5(false);
  };

  const fetchValorPetro = async () => {
    const endpoint = op.conexion + "/api/efiscal/valorpetro";
    const response = await axios.get(endpoint, {
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
    });
    if (response.status === 200) {
      setValorUT(response.data.valor);
    }
  };

  const fetchRegistros = async () => {
    const campos = "*";
    const nomtab = "comercio";
    const orden = "idcomercio";
    const endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    const response = await axios.get(endpoint, {
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
    });
    if (response.status === 200 && response.data) {
      setRecords(response.data);
    }
  };

  const fetchConfiguracion = async () => {
    const campos = "*";
    const nomtab = "configLicores";
    const orden = "1";
    const endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    const response = await axios.get(endpoint, {
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
    });
    if (response.status === 200) {
      setDeclaWeb(response.data[0].declaracionweb);
    }
  };

  useEffect(() => {
    const cargarDatosIniciales = async () => {
      setActivate(true);
      try {
        await Promise.all([
          fetchRegistros(),
          fetchValorPetro(),
          fetchConfiguracion(),
        ]);
      } catch (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto:
            error.response?.data?.message || "Error al cargar datos iniciales",
          icono: "error",
        });
      } finally {
        setActivate(false);
      }
    };

    cargarDatosIniciales();
  }, []);

  const seleccionarRegistro = (idcomercio) => async (e) => {
    e.preventDefault();
    setActivate(true);
    try {
      const campos = "*";
      const nomtab = "comercio";
      const nomid = "idcomercio";
      const endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idcomercio}&nomtab=${nomtab}&nomid=${nomid}`;

      const response = await axios.get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200 && response.data.idcomercio > 0) {
        setComercio(response.data);
        await seleccionarDeuda(response.data);
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: error.response?.data?.message || "Error al seleccionar registro",
        icono: "error",
      });
      setActivate(false);
    }
  };

  const seleccionarDeuda = async (data) => {
    try {
      const nomtab = "licores";
      const nomid = "idcomercio";
      const endpoint = `${op.conexion}/api/licores/deudalicores?nomtab=${nomtab}&nomid=${nomid}&id=${data.idcomercio}`;

      const response = await axios.get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200) {
        const mm =
          response.data.fechainscripcion === null
            ? 0
            : parseInt(
                moment
                  .utc(response.data.fechainscripcion)
                  .format("YYYY-MM-DD")
                  .substring(5, 7),
              );

        const meses = {
          1: "ENERO",
          2: "FEBRERO",
          3: "MARZO",
          4: "ABRIL",
          5: "MAYO",
          6: "JUNIO",
          7: "JULIO",
          8: "AGOSTO",
          9: "SEPTIEMBRE",
          10: "OCTUBRE",
          11: "NOVIEMBRE",
          12: "DICIEMBRE",
        };

        const deu = [];
        const his = [];

        for (let i = 0; i < response.data.length; i++) {
          const mes = meses[mm] || "";

          if (!response.data[i].cancelada) {
            deu.push({
              anio: response.data[i].anio,
              mes: mes,
              descripcion: response.data[i].descripcion,
              monto: response.data[i].monto,
            });
          } else {
            his.push({
              anio: response.data[i].anio,
              mes: mes,
              descripcion: response.data[i].descripcion,
              monto: response.data[i].monto,
              numereci: response.data[i].numerorecibo || " ",
              fechapago: response.data[i].fechapago
                ? moment.utc(response.data[i].fechapago).format("YYYY/MM/DD")
                : "",
            });
          }
        }
        setDeuda(deu);
        setHistorico(his);
      }
      setMostrar5(true);
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: error.response?.data?.message || "Error al consultar deuda",
        icono: "error",
      });
    } finally {
      setActivate(false);
    }
  };

  const exitHandler = () => {
    props.setTabla(0);
  };

  return (
    <div className="col-8 m-0 p-2 border rounded">
      <header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant rounded-top text-light">
        <h3 className="fw-bold m-0">Gestion de Estado de Cuenta Licores</h3>
        <a onClick={exitHandler} className="text-light fw-bold fs-6">
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </header>
      <div className="col-4 m-0 my-2 p-0">
        <SearchInput
          placeholder="Buscar"
          onChange={handleSearch2}
          name="Search"
        />
      </div>
      <div className="col-12 m-0 p-0">
        <TblContainer>
          <TblHead />
          <tbody>
            {records &&
              recordsAfterPagingAndSorting().map((item, index) => (
                <tr key={item.idcomercio} style={{ padding: "0" }}>
                  <td
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "10px",
                    }}
                  >
                    {item.idcomercio}
                  </td>
                  <td
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "10px",
                    }}
                  >
                    {item.ritm}
                  </td>
                  <td
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "80px",
                    }}
                  >
                    {item.rif}
                  </td>
                  <td
                    style={{
                      fontSize: "10px",
                      textAlign: "left",
                      width: "auto",
                    }}
                  >
                    {item.nombre}
                  </td>
                  <td
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "auto",
                    }}
                  >
                    {item.reprelegal}
                  </td>
                  <td
                    className="py-1"
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "10px",
                    }}
                  >
                    <button
                      onClick={seleccionarRegistro(item.idcomercio)}
                      className="btn btn-sm btn-info rounded-pill"
                    >
                      <i className="fas fa-search"></i>
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </TblContainer>
        <TblPagination />
      </div>
      <ModalCuentaEstado
        show={mostrar5}
        comercio={comercio}
        onHideCancela={cerrarModalActualizar}
        deuda={deuda}
        historico={historico}
        declaWeb={declaWeb}
        petro={valorUT}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <Dimmer active={activate} inverted></Dimmer>
    </div>
  );
}
